import { STATUS } from "@/lib/format";

export default function StatusBadge({ status }) {
  const s = STATUS[status] || STATUS.draft;
  return (
    <span
      data-testid={`status-${status}`}
      className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-xs font-medium tracking-wide ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
